import { Pipe, PipeTransform } from '@angular/core';
import { formatDateToLocaleDate } from '@epicuro-next/utilities';

const DATE_FORMAT = 'MMM d, yyyy';

@Pipe({
  name: 'localeDate',
  standalone: true,
})
export class FormattedLocaleDatePipe implements PipeTransform {
  public transform(
    value: string,
    locale: string,
    format = DATE_FORMAT,
  ): string | null {
    return formatDateToLocaleDate(value, locale, format);
  }
}
